 
// ekho-srcoll-image-container排序
$(document).ready(function(){
$(".ekho-srcoll-image-container").each(function(index){
  $(this).addClass(`ekho-srcoll-image-container-${index+1}`);
})
})

// 修改ins 插件样式
// //  shadowRoot Append style
let a_timeNum = 0;
let a_timer;

a_timer = setInterval(() => {
let picsWrap = document.querySelector(".needsclick");
a_timeNum++;
console.log("------------" + picsWrap);
if (picsWrap) {
  clearInterval(a_timer);
  let style = document.createElement("style");
  style.innerHTML = `
    .filters{
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
    }
    
    .btn-filter.selected{
      color:#ffffff;
      opacity:1;
    }
    .filters .btn-filter{
      opaicty:1;
      color:#ffffff;
      font-size:16px;
    }
    .btn-load-more.btn_style_1{
      height: 40px;
      background: #FFFFFF!important;
      border-radius: 8px!important;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding:8px 25px;
      margin-top: 15px;
      font-size: 16px;
      border: 2px solid #fff;
      color: #222!important;
    }
    .filters .btn-filter+.btn-filter{
          border: none;
        
              opacity: 1;
    }
    .filters .btn-filter{
      transition: all .5s;
    }
    .filters .btn-filter:hover{
          background: #F5F5F5;
          border-radius: 5px;
              color: #999;
    }
    .filters .btn-filter:active,
    .filters .btn-filter:focus{
          background: #F5F5F5;
          border-radius: 5px;
          color:#CB652F;
    }
    .btn-load-more.btn_style_1{
          padding: 10px 30px;
          color: #FFF;
          border-radius: 90px;
          background: #ED3239;
          margin-top:60px;
          margin-bottom: 0;
    }
    .filters{
      overflow-x: auto;
}
    @media (max-width:768px) {
         
          .filters .btn-filter{
             font-size: 14px;
             padding: 5px 10px;
             margin-right: 10px;
             background: #F5F5F5;
             border-radius: 5px;
             
          }
          .upload-widget{
                display: none;
          }
          .btn-load-more.btn_style_1{
                margin-top: 30px;
                    font-weight: 500;
          }
          .filters .btn-filter+.btn-filter{
          color: #222;
          }
    }
    `;
  picsWrap.shadowRoot.appendChild(style);
  return;
} else if (a_timeNum == 10) {
  // Only 10 times are queried, and if the element is not queried after ten times, the style is not appended
  clearInterval(a_timer);
}
}, 2000);
